
<section v-if="Boolean(card.playerIndexId || card.otherIndexId)" class="card-profile-index">
  <h4 v-if="index" class="secondary-font">
    Index
  </h4>

  <div v-if="index" class="container" @click="openIndex">
    <index-list-item :index="index" />
  </div>
</section>
